import React from 'react';
import CLFormActionModal from 'common/src/components/CLForm/CLFormActionModal/CLFormActionModal';
import {addFolderInitialValue, addFolderValidationSchema} from './CreateAssetFolderModal.consts';
import digitalAssetsApi from 'common/src/modules/digitalAsstesManager/digitalAssetsManager.api';
import {CreateFolderForm} from './CreateAssetFolderModal.types';
import CLFormInput from 'common/src/components/CLForm/CLFormInput/CLFormInput';
import {handleApiError} from 'common/src/modules/errorHandling/handleApiError';

interface CreateAssetFolderModalProps {
  onClose(): void;
  onSubmit(): void;
  workingFolder: string;
}

function CreateAssetFolderModal({onClose, onSubmit, workingFolder}: CreateAssetFolderModalProps) {
  function handleSubmit({name}: CreateFolderForm) {
    return digitalAssetsApi.createFolder(name, workingFolder).then(onSubmit).catch(handleApiError);
  }

  return (
    <CLFormActionModal
      title="Create Folder"
      width="400px"
      isOpen
      onCancel={onClose}
      initialValues={addFolderInitialValue}
      validationSchema={addFolderValidationSchema}
      onSubmit={handleSubmit}
    >
      {() => (
        <>
          <CLFormInput name="name" label="Folder Name" autoFocus />
        </>
      )}
    </CLFormActionModal>
  );
}

export default CreateAssetFolderModal;
